import { render, staticRenderFns } from "./goods-list.vue?vue&type=template&id=24460dbe&scoped=true&"
import script from "./goods-list.vue?vue&type=script&lang=js&"
export * from "./goods-list.vue?vue&type=script&lang=js&"
import style0 from "./goods-list.vue?vue&type=style&index=0&id=24460dbe&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24460dbe",
  null
  
)

export default component.exports